import { render, staticRenderFns } from "./ABTestVariation.vue?vue&type=template&id=79ba4335&"
import script from "./ABTestVariation.vue?vue&type=script&lang=js&"
export * from "./ABTestVariation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports